import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import ImportCenterPage from "../pages/ImportCenterPage";

const api = process.env.REACT_APP_BACKEND_URL;

export default function ProtectedImportCenter() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  useEffect(() => {
    axios
      .get(`${api}/api/auth/me`, { withCredentials: true })
      .then((response) => {
        if (!["owner", "admin"].includes(response.data.role))
          throw new Error("denied");
        setUser(response.data);
      })
      .catch(() => navigate("/dashboard", { replace: true }));
  }, [navigate]);
  if (!user)
    return (
      <main className="auth-check" data-testid="import-center-auth-check" />
    );
  const logout = async () => {
    await axios.post(`${api}/api/auth/logout`, {}, { withCredentials: true });
    navigate("/login", { replace: true });
  };
  return <ImportCenterPage user={user} onLogout={logout} />;
}
